import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledBoxContent,
  StyledBoxDown,
  StyledButton,
  StyledButtonPlus
} from './style';

import AwardItem from './AwardItem';
import Modal from '../../../core/Modal';
import { AWARDS } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class Awards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.dataAwards,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onChangeDropDownInput = (index, key, event) => {
    const { data } = this.state;
    const clonedData = [...data];
    let date = event.value;

    if (key === 'year') {
      date = `${date}-${clonedData[index].date.split('-')[1]}`;
    } else {
      date = `${clonedData[index].date.split('-')[0]}-${date}`;
    }

    clonedData[index] = { ...clonedData[index], date };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  getBtnStatus = data => {
    const { dataAwards } = this.props;

    return _.isEqual(dataAwards, data);
  };

  getLabelMonth(date) {
    const { listMonths } = this.props;
    const month = date.split('-')[1];
    const label = listMonths.find(objMonth => objMonth.value === month).text;

    return label;
  }

  getLabelYear(date) {
    const { listYears } = this.props;
    const year = date.split('-')[0];
    const label = listYears.find(objYear => objYear.value === year).text;

    return label;
  }

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const updatedData = data.filter(ele => ele.title && ele.date);

    onAcceptModal(updatedData);
  };

  handleChange = (value, index, key) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = { ...clonedData[index], [key]: value };

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { selectedMonths, selectedYears } = this.props;
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      title: '',
      date: `${selectedYears}-${selectedMonths}`
    });

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  render() {
    const {
      listMonths,
      listYears,
      onCloseModal,
      selectedMonths,
      selectedYears
    } = this.props;
    const { data, btnIsDisabled } = this.state;
    return (
      <Modal title={AWARDS.TITLE} clickCloseIcon={onCloseModal}>
        <StyledBoxContent>
          {data.map((item, index) => {
            const labelSelectedMonth = item.date
              ? this.getLabelMonth(item.date)
              : selectedMonths;
            const labelSelectedYear = item.date
              ? this.getLabelYear(item.date)
              : selectedYears;

            return (
              <AwardItem
                key={`${item.date}${index + 1}`}
                listMonths={listMonths}
                listYears={listYears}
                onChangeInput={e => this.handleChange(e, index, 'title')}
                onClickDelete={() => this.onClickDelete(index)}
                onClickDown={() => this.onClickOrderArrow(index, true)}
                onClickUp={() => this.onClickOrderArrow(index, false)}
                order={index + 1}
                title={item.title}
                labelMonth={labelSelectedMonth}
                selectedMonth={labelSelectedMonth}
                onSelectMonth={e =>
                  this.onChangeDropDownInput(index, 'month', e)
                }
                labelYear={labelSelectedYear}
                selectedYear={labelSelectedYear}
                onSelectYear={e => this.onChangeDropDownInput(index, 'year', e)}
              />
            );
          })}
          <StyledButtonPlus onClick={this.handlePlus} dark />
          <StyledBoxDown>
            <StyledButton onClick={onCloseModal} modal>
              {AWARDS.CANCEL}
            </StyledButton>
            <StyledButton
              onClick={this.handleAccept}
              secondary
              disabled={btnIsDisabled}
            >
              {AWARDS.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxContent>
      </Modal>
    );
  }
}

Awards.propTypes = {
  dataAwards: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      title: PropTypes.string
    })
  ),
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ).isRequired,
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  selectedMonths: PropTypes.string,
  selectedYears: PropTypes.string
};

Awards.defaultProps = {
  dataAwards: [],
  selectedMonths: '01',
  selectedYears: '2018'
};

export default Awards;
